<template>
  <div class="shrink">
    <input
        tabindex="1"
        :dense="true"
        v-model='content'
        :type="isTouchDevice()?'number':null"
        ref='timer'
        placeholder="--.--"
        onfocus='this.select();'
        @blur="report"
        :style='stl'
        class="timer-input"
        @keypress='filterForValidation'
        @keyup='filterFordot'></input>
  </div>
</template>
<style scoped>
input.timer-input {
  width: 100%;
  text-align: center;
  border: none;
  padding-left: 1%;
  padding-right: 1%;
  height: 2.2em;
  border-bottom: 1px solid #0b6d3b85;
}

.dark input {
  background-color: #194249;
  color: wheat;
}

.dark input:focus {
  background-color: #194249;
  color: wheat;
}
</style>
<script>
// pattern="^([0]?[1-9]|[1|2][0-9]|[3][0|1])/([0]?[1-9]|[1][0-2])/(19|20)\d\d$"
import mdl from '~/mixins/mdl';

export default {
  name: 'AutoTimepicker',
  data: function () {
    return {
      content: null,
      stl: null,
      justFocushed: true,
    };
  },
  // declare the props
  props: {
    noUpdate: {type: Boolean, default: false},
    unixtime: {type: Boolean, default: false},
    timeint: {type: Boolean, default: true},
    value: {
      type: [String,
        Number,
        Boolean], default: null
    },
    incomingSeperator: {type: String, default: ':'},
    offset: {type: Number, default: 0}
  },
  // like data, the prop can be used inside templates and
  // is also made available in the vm as this.message
  // template:
  //     "<input   v-model='content' ref='timer' onfocus='this.select();' :style='stl' @keypress='filterForValidation' @keyup='filterFordot' @change='$emit(\"input\",content)'></input>",
  watch: {
    value: function (value, ov) {
      _log_("chenging in?" + value, this.outcomingValue);

      if (value != ov && value != this.outcomingValue) this.content = this.incomingValue ? (this.incomingValue + "").replace(":", ".") : null;
      //
    },
    content: _.debounce(function (value, ov) {
      if (this.incomingValue == value) {
        this.stl = null
        return
      }
      if (ov != value) {
        const ps = value ? value.split(".") : [];
        if (!ps[1]) this.stl = "color:red;background:yellow";
        else if (
            parseInt(ps[1]) >= 0 &&
            parseInt(ps[1]) < 59 &&
            parseInt(ps[0]) >= 0 &&
            parseInt(ps[0]) < 24
        ) {
          const vm = this

          // if (parseInt(ps[0]) < 10) this.content = '0' + ps[0]
          // else this.content = ps[0]
          // this.content += '.'
          // if (parseInt(ps[1]) < 10) this.content += '0' + ps[1]
          // else this.content = ps[1]

          this.stl = null;
          _log_('chenging.report !tm!..', this.noUpdate, vm.incomingValue, value, ov)

          _log_('report chenging.!tm!.input.', vm.incomingValue, value, ov)
          vm.$emit("input", this.outcomingValue);

          // vm.$emit("change", this.outcomingValue);
          //   _.debounce(
          //       ()=> {
          //         _log_('chenging.!tm!..', vm.incomingValue, value, ov)
          //         vm.$emit("input", this.outcomingValue);
          //         vm.$emit("change", this.outcomingValue);
          //       },800
          // )
        } else this.stl = "color:red;background:yellow";
      }
      //
    }, 800),
  },
  computed: {
    incomingValue() {
      if (!this.value) return ''
      if (this.timeint) {
        const tmH = Math.floor(parseInt(this.value + this.offset) / 60), tmM = parseInt(this.value + this.offset) % 60
        return (tmH < 10 ? '0' + tmH : tmH) + '.' + (tmM < 10 ? '0' + tmM : tmM)
      } else
        return this.value.replace(this.incomingSeperator, ".");
    },
    outcomingValue() {
      if (!this.content || this.stl) return ''
      if (this.timeint) {
        const tmPrts = this.content.split(".");
        return parseInt(tmPrts[0]) * 60 + parseInt(tmPrts[1]) - this.offset
      } else
        return this.content.replace(".", this.incomingSeperator);
    }
  },
  methods: {
    report() {
      if (this.stl) {

        this.content = null
        return
      }
      _log_("report k.v.", this.outcomingValue);
      this.$emit('change', this.outcomingValue);
    },
    // checkSelection(){
    //   _log_("checkSelection k.v." ,this.$refs.timer,this.$refs.timer.selectionStart,this.$refs.timer.selectionEnd);
    // },
    init() {
    },
    disableFocus(event) {
      // _log_("k.vASR..", event);
    },
    filterForValidation(event) {
      _log_("checkSelection k.v.", event, this.$refs.timer, this.$refs.timer.selectionStart, this.$refs.timer.selectionEnd);
      if (event.key == 'Enter') {
        event.preventDefault();
        this.report()
        return;
      }
      // if (this.$refs.timer.selectionEnd > 1) {
      //   event.preventDefault();
      //   return
      // }

      // if (this.content.indexOf(".") >= 0)
      //   if (this.content.length > 5)// && event.target.selectionStart)
      //     event.preventDefault();
      //   else if (this.content.length > 4)// && event.target.selectionStart)
      //     event.preventDefault();
      if (
          (event.shiftKey || event.keyCode < 48 || event.keyCode > 57) &&
          event.keyCode != 46 &&
          event.keyCode != 44
      ) {
        event.preventDefault();
      }
      // if (event.keyCode == 46 || event.keyCode == 44) {
      //   //    _log_("k.C.F." + this.content);
      //   if (this.formatgreek && this.content.indexOf(",") > -1)
      //     event.preventDefault();
      //   if (!this.formatgreek && this.content.indexOf(".") > -1)
      //     event.preventDefault();
      // }
    },
    filterFordot(event) {
      if (this.isTouchDevice()) return;
      const isDelete = event.code == 'Backspace' || event.code == 'Delete'
      _log_("k..", event.keyCode, event, event.target.selectionStart)
      if (event.key == "ArrowLeft" || event.key == "ArrowRight")
        this.justFocushed = false;

      if (!this.content) return
      _log_("k...go 1")
      if (
          (event.shiftKey || event.keyCode < 48 || event.keyCode > 57) &&
          event.keyCode != 46 &&
          event.keyCode != 44
      ) {
        _log_("k...go 2", event.keyCode)
        if (event.keyCode < 96 || event.keyCode > 105) {
          event.preventDefault();
          if (!isDelete) return
        }
      }
      let ps =
          this.content.indexOf(".") < 0
              ? this.content.match(/.{1,2}/g)
              : this.content.split(".");
      const dotPosition = ps[1] ? this.content.indexOf('.') + 1 : 0
      _log_("k....3.filterFordot.", ps, this.content, this.value)
      if (!isDelete && ps[0] && ps[0].length > 2 && dotPosition >= event.target.selectionStart) {

        // return;
        const secPrts = ps[0].split('')
        if (event.target.selectionStart < 2)
          secPrts[0] = event.key
        else secPrts[1] = event.key
        ps[0] = secPrts[0] + secPrts[1]
        this.content = ps.join(".");
        return;
        // if (ps[0].length < 2 && parseInt(ps[0]) <= 24 && parseInt(ps[0] + secPrts[0]) <= 24) {
        //   ps[0] = ps[0] + secPrts[0]
        //   ps[1] = secPrts[1] + secPrts[2]
        // }
        // else ps[1] = secPrts[secPrts.length - 2] + secPrts[secPrts.length - 1]
      }
      if (ps[1]) {
        const chars = ps[1].split('')
        if (!isDelete && chars[1] == '0') ps[1] = chars[0] + event.key
      }

      if (ps[1] && ps[1].length > 2) {
        const secPrts = ps[1].split('')
        if (ps[0].length < 2 && parseInt(ps[0]) <= 24 && parseInt(ps[0] + secPrts[0]) <= 24) {
          ps[0] = ps[0] + secPrts[0]
          ps[1] = secPrts[1] + secPrts[2]
        } else ps[1] = secPrts[secPrts.length - 2] + secPrts[secPrts.length - 1]
      } else if (!ps[1] && parseInt(ps[0]) > 24) {
        const chars = this.content.split('')
        ps[0] = chars[0]
        ps[1] = chars[1]
      }

      if (!isDelete) if (ps[1] && ps[1].length == 1) ps[1] = ps[1] + '0'
      // if (ps[1] && ps[1].length >2 )  {
      //   const chars = this.content.split('')
      //   ps[0] = chars[0]
      //   ps[1] = chars[1]
      // }


      if (event.keyCode == 46 || event.keyCode == 44) {
        _log_("k.C.F." + this.content);
        if (this.formatgreek && this.content.indexOf(",") > -1)
          event.preventDefault();
        if (!this.formatgreek && this.content.indexOf(".") > -1)
          event.preventDefault();
      }
      if (ps && ps[1] && ps[1].length < 3) this.content = ps.join(".");
      else {

        event.preventDefault();
        return
      }
    },
  },
  mounted() {
    if (this.value) {
      this.content = this.incomingValue
    }
    // var vm = this,
    //   tF = "H.i",
    //   $this = $(this.$el),
    //   sDate = new Date();
    // if (this.seperator) tF = "H" + this.seperator + "i";
  },
}
</script>
